import { isMicrosoftOfficeType } from 'src/utils/mime';
import { BlockContent } from '../types';

export const ACCEPTED_IMAGE_MIME_TYPES = ['image/png', 'image/jpeg', 'image/gif'];

export function fileToBlockContentType(file: File): BlockContent['type'] {
  if (!file || !file.type) return 'attachment';

  if (file.type === 'application/pdf') {
    return 'pdf';
  }
  // Before the attachment fallback: an .html file dropped on a Journey should
  // render as a page, not download as a file. Sniffed again server-side, since
  // file.type comes from the browser and is not trustworthy on its own.
  if (file.type === 'text/html') {
    return 'html';
  }
  if (file.type.startsWith('video/')) {
    return 'video';
  }

  if (ACCEPTED_IMAGE_MIME_TYPES.includes(file.type)) {
    return 'image';
  }

  if (isMicrosoftOfficeType(file.type)) {
    return 'ms-office';
  }

  return 'attachment';
}
